
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FeatureOff extends Vue {
  @Prop({ required: true }) isOn!: boolean;
}
